import { Segmented } from "antd"
import { useLocation, useNavigate, useParams } from "react-router"

import PublicApiPage from "./components/PublicApiPage"
import WebhooksPage from "./components/WebhooksPage"

import "./styles.less"

const pageOptions = [
  { value: "public_api", label: "Public API" },
  { value: "webhooks", label: "Webhooks" }
]

const PublicAPI = ({ user_id }) => {
  const { hash } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const page = ["public_api", "webhooks"].includes(hash) ? hash : "public_api"
  const isDevelopersPage = pathname.startsWith("/developers")
  const baseRoute = isDevelopersPage ? "/developers" : "/settings"

  return (
    <div className="public-api">
      <div className="public-api-segmented">
        <Segmented
          options={pageOptions}
          onChange={(val) => navigate(`${baseRoute}/${val}`)}
          value={page}
        />
      </div>
      {page === "public_api" && <PublicApiPage />}
      {page === "webhooks" && <WebhooksPage />}
    </div>
  )
}

export default PublicAPI
